export const validateServiceType = (_type = '0000000000000000', _service_name) => {
    if (!!!_type) _type = "";
    if (_service_name === 'channel' && _type.substring(0, 1) === '1') return true
    if (_service_name === 'household' && _type.substring(1, 2) === '1') return false
    if (_service_name === 'product' && _type.substring(2, 3) === '1') return true
    if (_service_name === 'examination' && _type.substring(3, 4) === '1') return true

    return false
}

export const getServiceTypes = (_type = '0000000000000000') => {
    if (!!!_type) _type = "";
    let _service_names = {}
    if (_type.substring(0, 1) === '1')
        _service_names = {..._service_names, 'channel-allowable': true}
    if (_type.substring(1, 2) === '1')
        _service_names = {..._service_names, 'household-allowable': true}
    if (_type.substring(2, 3) === '1')
        _service_names = {..._service_names, 'product-allowable': true}
    if (_type.substring(3, 4) === '1')
        _service_names = {..._service_names, 'examination-allowable': true}

    return _service_names
}
